import React from 'react';
import '../button/Button.css';

const ButtonEndStepsInformativo = ({ callFunction, buttonName }) => {
  return (
    <button
      name={buttonName}
      className="botonInformativoEntendido"
      type="submit"
      onClick={callFunction}
    >
      {' '}
      {buttonName}
      {' '}
    </button>
  );
};

export default ButtonEndStepsInformativo;
